import { lazy } from 'react';
import { Navigate } from 'react-router';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ADD_CARE_RECIPIENT_PATH,
  ADD_CARE_RECIPIENT_SUCCESS_PATH,
  CARE_RECIPIENT_FILL_MY_INFO_PATH,
  UPDATE_CARE_RECIPIENT_PATH,
  UPDATE_CARE_RECIPIENT_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const LazyAddCareRecipientContainer = lazy(
  () => import('@features/Caregivers/FamilyFriends/CareRecipients/components/AddCareRecipientContainer')
);
const LazyAddedStatusPanel = lazy(
  () => import('@features/Caregivers/FamilyFriends/CareRecipients/components/AddedStatusPanel')
);

export const CARE_RECIPIENT_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddCareRecipientContainer />,
    displayTitle: () => 'Add Family & Friends',
    pageType: PageType.PRIVATE,
    path: ADD_CARE_RECIPIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddCareRecipientContainer />,
    displayTitle: () => 'Update Profile',
    pageType: PageType.PRIVATE,
    path: UPDATE_CARE_RECIPIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddedStatusPanel />,
    displayTitle: () => 'Add Family & Friends',
    pageType: PageType.PRIVATE,
    path: ADD_CARE_RECIPIENT_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddedStatusPanel isUpdate />,
    displayTitle: () => 'Update Profile',
    pageType: PageType.PRIVATE,
    path: UPDATE_CARE_RECIPIENT_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <Navigate replace to={ADD_CARE_RECIPIENT_PATH} />,
    displayTitle: () => 'Add Family & Friends',
    pageType: PageType.PRIVATE,
    path: CARE_RECIPIENT_FILL_MY_INFO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
];
